import { IWebinarItem } from 'marketing-site/src/components/bespoke/webinars-list'

export const sortWebinarsByDate = (webinars: IWebinarItem[]) => {
  return webinars.sort((a: IWebinarItem, b: IWebinarItem) => {
    if (a.webinar.zoom !== undefined && b.webinar.zoom !== undefined) {
      return a.webinar.zoom.startTimestamp > b.webinar.zoom.startTimestamp ? 1 : -1
    } else {
      return a.webinar.zoom?.startTimestamp !== undefined ? -1 : 1
    }
  })
}
